export function ComingSoonBadge() {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-sans font-medium uppercase tracking-wider bg-[var(--color-surface)] text-[var(--color-text-tertiary)] border border-[var(--color-border)]">
      Coming Soon
    </span>
  )
}
